import React from "react"
import Link from "gatsby-link"
import g from "glamorous"
import { css } from "glamor"
import breakpoints from "../components/breakpoints.jsx"

const StyledWorkListItem = g.li({
    position: `relative`,
    [breakpoints.TabletUp]: {
        margin: `1em`,
        paddingBottom: `1em`,
        maxWidth: `calc(50% - 2em)`,
        overflow: `hidden`,
        float: `left`,
        marginLeft: `0`,
        transition: `all 0.25s linear`,
        ':nth-child(2n)': {
            float: `right`,
            marginRight: `0`,
            marginLeft: `0`
        },
        ':after': {
            content: ` `,
            background: `linear-gradient(to right, rgba(193,239,220,1) 0%,rgba(171,239,190,0) 100%)`,
            position: `absolute`,
            top: `0`,
            left: `0`,
            width: `0`,
            height: `100%`,
            transition: `all 0.15s ease-in-out`,
            pointerEvents: `none`
        },
        ':hover': {
            opacity: `0.75`
        }
        /*':hover:after': {
            width: `100%`,
            animation: `${css.keyframes({
                '0%': { transform: `translateX(0)` },
                '100%': { transform: `translateX(-15%)` }
            })} 1s infinite ease-in-out alternate`
        }*/
    }
})



class WorkListItem extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            //maxWidth: Math.floor(Math.random() * 50) + 20 + '%',
            marginTop: Math.random() * 5 + 1 + 'em'
        }
    }
    render() {
        return (
            <StyledWorkListItem style={{marginTop: this.state.marginTop}}>
                <Link
                    to={`/work/` + this.props.slug}
                >
                <figure>
                    <img src={this.props.photo} alt={this.props.description} />
                    <figcaption>
                        <h3>{this.props.title}</h3>
                    </figcaption>
                </figure>
                </Link>
            </StyledWorkListItem>
        )
    }
}

export default WorkListItem


// WEBPACK FOOTER //
// ./src/components/work-list-item.js